/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useDocGroupStore = defineStore("docgroup", {
  actions: {
    async docGroupListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          "name:contains": payload.name,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/master-svc/docGrp/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async docGroupInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/master-svc/docGrp/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async docGroupAddFetch(payload) {
      const body = {
        code: payload.code,
        name: payload.name,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/master-svc/docGrp/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async docGroupUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        code: payload.code,
        name: payload.name,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/master-svc/docGrp/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async docGroupDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/master-svc/docGrp/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
